import { TabStyles } from '@tableau/widgets';

import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { SpaceContainerStyles } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { cssClass } from '../../style';

const cssPrefix = 'starters';

export const BreakPoints = {
  'SMALL': 375,
  'MEDIUM': 768,
};

export const StartersCardThumbnail = cssClass(cssPrefix, '-card-thumbnail', {
  position: 'relative',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  $nest: {
    '&:hover::after': {
      display: 'block',
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.4)',
      zIndex: 1,
    }
  }
});

export namespace InteractiveModalDialog {
  const interactiveVizCssPrefix = cssPrefix + '-interactive';
  export const InteractiveModalDialogWidth = '75';

  export const DialogContent = cssClass(interactiveVizCssPrefix, 'dialog-content', {
    marginTop: '24px',
    marginLeft: '24px',
    marginRight: '24px',
    marginBottom: '24px',
    display: 'flex',
    flexWrap: 'wrap',
  });

  export const DescriptionSection = cssClass(interactiveVizCssPrefix, '-dialog-description-section', {
    margin: 0,
    padding: 0,
    display: 'flex',
    maxWidth: '100%',
    minWidth: '120px',
    flex: '1 1 200px',
  });

  export const VizAndCarouselGroup = cssClass(interactiveVizCssPrefix, '-dialog-viz-and-carousel', {
    margin: 0,
    marginRight: '24px',
    padding: 0,
    display: 'flex',
    maxWidth: '100%',
    flexWrap: 'wrap',
    flex: '1 1 350px',
  });

  export const CloseButton = cssClass(interactiveVizCssPrefix, '-dialog-close-button', {
    display: 'flex',
    justifyContent: 'center',
    width: 30,
    height: 30,
    cursor: 'pointer',
  });


  export const CloseButtonContainer = cssClass(interactiveVizCssPrefix, '-dialog-close-button', {
    position: 'absolute',
    top: 5,
    right: 5,
    background: 'none',
    opacity: 0.5,
    lineHeight: 0,  // Default line height added extra height
    $nest: {
      '&:hover': {
        opacity: 1,
      },
      '.focus-visible': { // This class is created by the <Tooltip>. Workaround for a ButtonWidget not getting it's state updated
        backgroundColor: TabStyles.Colors.WhiteTransparent
      }
    },
  });



  export const InteractiveViz = cssClass(interactiveVizCssPrefix, '-viz', {
    position: 'relative',
    width: '100%',
    height: 0,//3/4 aspect ratio
    paddingTop: '75%',//3/4 aspect ratio
    display: 'flex',
    flex: '1',
    border: 'solid',
    borderWidth: TabStyles!.Sizing!.BorderWidth,
    borderColor: TabStyles!.Colors!.L4,
    marginBottom: '24px',
    maxWidth: '100%',
    minWidth: '100%',
  });

  export const ThumbnailCarousel = cssClass(interactiveVizCssPrefix, '-thumbnail-carousel', {
    display: 'flex',
  });
}

// Starters Space Styles
export namespace StartersSpaceStyle {
  const startersSpaceCssPrefix = 'starters-space';
  export const thumbnailImageSize = {width: '644px', height: '393px'};

  export const StartersToolBar = cssClass(startersSpaceCssPrefix, 'toolbar', {
    fontWeight: 'normal',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginLeft: SpaceContainerStyles.GlobalSpaceHorizontalPadding,
    marginRight: SpaceContainerStyles.GlobalSpaceHorizontalPadding,
    color: CommonStyles.Colors.Grey51
  });

  export const SpaceSubHeader = cssClass(startersSpaceCssPrefix, 'sub-header', {
    paddingTop: '4px',
    paddingRight: TabStyles.Spacing.MediumSpace,
    fontSize: '14px',
  });

  export const startersSpaceStartersArea = cssClass(startersSpaceCssPrefix, 'starters-area', {
    padding: '24px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
  });

  export const startersSpaceStartersAreaItem = cssClass(startersSpaceCssPrefix, 'starters-area-item', {
    paddingTop: '24px',
    paddingBottom: '24px',
    display: 'flex',
    alignItems: 'flex-start',
    marginLeft: '24px',
  });

  export const startersSpaceStartersAreaItemDescription = cssClass(startersSpaceCssPrefix, 'starters-area-item-description', {
    display: 'flex',
    flex: '1 1 200px',
    marginLeft: '30px',
  });

  export const startersSpaceStartersAreaItemImage = cssClass(startersSpaceCssPrefix, 'starters-area-item-thumbnail', {
    width: '644px',
    height: '393px',
    border: '1px',
    color: '#cbcbcb',
  });

  export const startersEmptySpace = cssClass(startersSpaceCssPrefix, 'starters-area-empty', {
    paddingLeft: '24px',
    fontSize: '18px',
  });

  export const startersDropdown = cssClass(startersSpaceCssPrefix, 'starters-dropdown', {
    minWidth: '200px',
  });
}
